
export const TRENDS_KEYS = [
	"TEMPERATURE",
	"SET_POINT",
	"ON_OFF",
	"MODE",
	"FAN_SPEED",
	"POWER_METER",
	"GAS_METER",
	"APPARENT_POWER",
    "VOLTAGE",
    "CURRENT",
    "POWER_FACTOR",
	"HUMIDITY",
	"CO2",
	"PM10",
	"PM2_5",
	"VOC",
	"MOTION_START_END",
	"PRESSURE",
	"ELECTRICITY_CONSUMPTION",
    "PEOPLE_IN",
    "PEOPLE_OUT",
    "OCCUPIED",
    "STANDBY_DEADBAND",
    "BYPASS_TIME",
];

export const OCCUPANCY_KEYS = [
    "OCCUPANCY_EVENT",
    "OCCUPANCY_COUNT",
    "MOTION_EVENT",
]

export const KEYS = [...TRENDS_KEYS, ...OCCUPANCY_KEYS];

// used to put together the right kind of trend chart
export const CATEGORICAL = [
    "FAN_SPEED",
    "MODE",
    "ON_OFF",
    "MOTION_START_END",
    "OCCUPIED"
];

export const KEY_TO_TEXT = {
	"TEMPERATURE": "Temperature",
	"SET_POINT": "Set point",
	"ON_OFF": "On/off",
	"MODE": "Mode",
	"FAN_SPEED": "Fan speed",
	"POWER_METER": "Electricity meter",
	"GAS_METER": "Gas meter",
	"APPARENT_POWER": "Apparent power",
    "VOLTAGE": "Voltage",
    "CURRENT": "Current",
    "POWER_FACTOR": "Power factor",
	"HUMIDITY": "Humidity",
	"CO2": "CO2",
	"PM10": "PM 10",
	"PM2_5": "PM 2.5",
	"VOC": "VOC",
	"MOTION_START_END": "Motion start/end",
	"PRESSURE": "Pressure",
	"ELECTRICITY_CONSUMPTION": "Electricity consumption",
    "PEOPLE_IN": "People in",
    "PEOPLE_OUT": "People out",
    "OCCUPIED": "Occupied",
    "STANDBY_DEADBAND": "Standby deadband",
    "BYPASS_TIME": "Bypass time",
	"OCCUPANCY_EVENT": "Occupancy event",
	"OCCUPANCY_COUNT": "Occupancy count",
	"MOTION_EVENT": "Motion event"
};

export const KEY_TO_UNIT = {
	"TEMPERATURE": "°C",
	"SET_POINT": "°C",
	"POWER_METER": "kW",
	"GAS_METER": "kW",
	"APPARENT_POWER": "kVA",
    "VOLTAGE": "V",
    "CURRENT": "A",
	"HUMIDITY": "%",
	"CO2": "ppm",
	"PM10": "µg/m³",
	"PM2_5": "µg/m³",
	"VOC": "ppb",
	"PRESSURE": "hPa"
}

export const ALLOWED_INPUT_CATEGORICAL_VALUES = {
    "ON_OFF": ["ON", "OFF"],
    "MODE": [
        "AUTO", "HEAT", "DRY", "FAN", "COOL", "AUTO_HEAT", "AUTO_COOL", "SETBACK", "SETBACK_HEAT", "SETBACK_COOL"
    ],
    "FAN_SPEED": [
        "AUTO", "1", "2", "3", "4"
    ],
    "MOTION_START_END": ["START", "END"],
    "OCCUPIED": ["1", "0"]
};

export const ENVIRONMENTAL_KEY_TO_TEXT = {
	"OUTSIDE_TEMP": "Outside temperature",
	"DIRECT_IRRADIANCE": "Direct irradiance"
};

export const ENVIRONMENTAL_KEY_TO_UNIT = {
	"OUTSIDE_TEMP": "°C",
	"DIRECT_IRRADIANCE": "W/m²"
};


